var map = {
	"./icon--arrow-left.svg": 7373,
	"./icon--arrow-right.svg": 4464,
	"./icon--check.svg": 2114,
	"./icon--chevron-down.svg": 1256,
	"./icon--cross.svg": 3586,
	"./icon--download.svg": 4378,
	"./icon--menu-burger.svg": 1715,
	"./icon--menu-close.svg": 3232,
	"./icon--minus.svg": 6078,
	"./icon--phone.svg": 9666,
	"./icon--plus.svg": 8886,
	"./path--person-details.svg": 2742,
	"./path--person-headshot.svg": 3378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3394;